import { unstable_useControlled as useControlled } from '@material-ui/utils';
export default useControlled;